module.exports = __webpack_public_path__ + "static/media/attack-number-8.9c4c6590.png";